import React from 'react';
import { Link } from 'react-router-dom';
import { faqSections } from '../data/faq';

interface FaqProps {
  /** Max number of questions to show (e.g. 5 for homepage teaser). Omit for full FAQ list. */
  limit?: number;
  /** Show section headings (e.g. "What We Do", "Services & Conditions") */
  showSections?: boolean;
  /** Show "View all FAQs" link at the bottom */
  showViewAllLink?: boolean;
}

const Faq: React.FC<FaqProps> = ({ limit, showSections = true, showViewAllLink = false }) => {
  const itemsWithSection = faqSections.flatMap((section) =>
    section.items.map((item) => ({ ...item, sectionHeading: section.heading }))
  );
  const displayedItems = limit ? itemsWithSection.slice(0, limit) : itemsWithSection;

  return (
    <section className="faq">
      {showSections && !limit ? (
        faqSections.map((section) => (
          <div key={section.heading} className="faq-section">
            <h2 id={`faq-${section.heading.toLowerCase().replace(/\s+/g, '-')}`} className="faq-section-title">
              {section.heading}
            </h2>
            <div className="faq-list" role="list">
              {section.items.map((item, index) => (
                <div key={index} className="faq-item" role="listitem">
                  <details className="faq-details">
                    <summary className="faq-question">
                      <span>{item.question}</span>
                    </summary>
                    <div className="faq-answer">
                      {item.answer}
                    </div>
                  </details>
                </div>
              ))}
            </div>
          </div>
        ))
      ) : (
        <div className="faq-section">
          <div className="faq-list" role="list">
            {displayedItems.map((item, index) => (
              <div key={index} className="faq-item" role="listitem">
                <details className="faq-details">
                  <summary className="faq-question">
                    <span>{item.question}</span>
                  </summary>
                  <div className="faq-answer">
                    {item.answer}
                  </div>
                </details>
              </div>
            ))}
          </div>
          {showViewAllLink && limit && (
            <Link to="/faq" className="faq-view-all">
              View all FAQs
            </Link>
          )}
        </div>
      )}
    </section>
  );
};

export default Faq;
